import { Bill, FiscalpopCFDI } from '../../../models/Factura';

type BillProperty = 'receptor' | 'conceptos' | 'cfdiRelacionados' | 'comprobante' | '_replace';

export function billReducer(state: Bill, { property, value }: { property: BillProperty, value: any }): Bill {
    if (property === 'receptor') {
        return Object.assign({}, state, { receptor: value });
    } else if (property === 'conceptos') {
        return Object.assign({}, state, { conceptos: value });
    }
    else if (property === 'comprobante') {
        return Object.assign({}, state, value);
    }
    else if (property === 'cfdiRelacionados') {
        return Object.assign({}, state, { cfdiRelacionados: value });
    }
    else if (property === '_replace') {
        return Object.assign({}, state, value);
    }
    else {
        // Force update only
        return Object.assign({}, state);
    }
}

/** Keeps the list of related bills the nota de crédito will apply to */
export function billRelatedReducer(state: FiscalpopCFDI[], { action, value }: { action: 'select' | 'unselect', value: FiscalpopCFDI }): FiscalpopCFDI[] {
    if (action === 'select') {
        return state.filter((s) => s.uuid !== value.uuid).concat([value])
    } else if (action === 'unselect') {
        return state.filter((b) => b.uuid !== value.uuid)
    } else {
        return state;
    }
}

export const EMPTY_CFDI = (): Bill => ({
    formaPago: '99',
    metodoPago: 'PUE',
    serie: 'DEV',
    folio: '1',
    tipoDeComprobante: 'E',
    receptor: { nombre: '', rfc: '', usoCFDI: 'G02', email: '' },
    cfdiRelacionados: {
        tipoRelacion: '03',
        uuids: ['']
    },
    conceptos: [{
        claveProdServ: '84111506',
        claveUnidad: 'ACT',
        cantidad: 1,
        descripcion: 'Devolucion',
        valorUnitario: 0,
        impuestos: [{ type: 'iva', tipo: 'Fijo', retencion: false, tasa: 0.16 }]
    }],
} as Bill)

/** Initial form value, EMPTY_CFDI with the receptor fields the form binds to */
export const INITIAL_CFDI = (): Bill => Object.assign(EMPTY_CFDI(), {
    receptor: { nombre: '', rfc: '', usoCFDI: 'G02', email: '', regimen: '', zip: '' }
} as Partial<Bill>)
